import React, { Component } from 'react';
import { SubmissionError } from 'redux-form';
import { toast } from 'react-toastify';

import {
  simoMassActivation,
  simoMassSyncActivation,
  quickMassActivation,
} from 'api';
import Spinner from 'components/Spinner';
import MassActivationForm from 'components/MassActions/Subs/MassActivationForm';

const carrierConfig = {
  simo: {
    massActivation: simoMassActivation,
    massSyncActivation: simoMassSyncActivation,
  },
  quick: {
    massActivation: quickMassActivation,
  },
};

class MassActivation extends Component {
  state = {
    result: null,
    loading: false,
  };

  handleSubmit = (values) => {
    const { carrier, isSync } = this.props;
    const { massActivation, massSyncActivation } = carrierConfig[carrier];
    const massActivationApi = isSync ? massSyncActivation : massActivation;

    let formData = new FormData();
    // depends on browser. Ex.: Chrome will have file list(array), Saferi - plain file
    let file = values.csv_file[0] ? values.csv_file[0] : values.csv_file;
    formData.append('csv_file', file);
    formData.append('send_result_to', values.send_result_to);

    this.setState({ loading: true });
    return massActivationApi(formData)
      .then((res) => {
        this.setState({ loading: false });
        toast.success('Requested mass activation successfully');
      })
      .catch((err) => {
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        this.setState({ loading: false, result: null });
        throw new SubmissionError(messages);
      });
  };

  render() {
    const { title, isSync } = this.props;
    const { loading } = this.state;
    const initialValues = { csv_file: '', send_result_to: '' };

    return (
      <div className="mar-t-40">
        <h2>{title ? title : 'Mass Activation'}</h2>
        <div className="relative">
          <MassActivationForm
            form={isSync ? 'massSyncActivationForm' : 'massActivationForm'}
            onSubmit={this.handleSubmit}
            initialValues={initialValues}
            btnText={title}
          />
          <Spinner showLoader={loading} />
        </div>
      </div>
    );
  }
}

export default MassActivation;
